const ITEMS = [
  "Grade-A Commercial Development",
  "Plot 1A, Sector 140, Noida Expressway",
  "5.9 Lac+ Sq.Ft Underway",
  "88 High-Speed Lifts",
  "Double-Height Retail & Food Court",
  "USGBC Gold Compliant",
  "RERA Registered — All Phases",
];

export default function Marquee() {
  const sequence = (
    <div className="flex shrink-0 items-center">
      {ITEMS.map((t) => (
        <span key={t} className="flex items-center">
          <span className="mx-10 font-mono text-[11px] uppercase tracking-[0.35em] text-[#9CA3AF]/70">{t}</span>
          <span className="text-[#D4AF37]/60 text-[8px]">◆</span>
        </span>
      ))}
    </div>
  );

  return (
    <div data-testid="editorial-marquee" className="overflow-hidden border-y border-white/[0.07] bg-[#0B0C0E] py-5">
      <div className="flex whitespace-nowrap animate-marquee w-max">
        {sequence}
        {sequence}
      </div>
    </div>
  );
}
